var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("GlobalEvents"),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "mdc-text-field input__field mdc-text-field--outlined mdc-text-field--with-trailing-icon",
          class: {
            "mdc-text-field--valid": _vm.validState,
            "mdc-text-field--invalid": _vm.invalid
          }
        },
        [
          _c("bk-outline-notched", {
            attrs: {
              id: _vm.id,
              label: _vm.label,
              "pre-filled": !_vm.searchTerm.isEmpty()
            }
          }),
          _vm._v(" "),
          _c("input", {
            staticClass: "mdc-text-field__input",
            class: {
              "data-hj-allow": _vm.allowHotjarRecording,
              "data-hj-suppress": !_vm.allowHotjarRecording
            },
            attrs: {
              autocomplete: "off",
              type: "text",
              id: _vm.id,
              "aria-controls": _vm.helperTextId,
              "aria-describedby": _vm.helperTextId
            },
            domProps: { value: _vm.searchTerm },
            on: {
              input: _vm.onInput,
              focus: function($event) {
                return _vm.$emit("focus")
              },
              blur: _vm.onBlur,
              keydown: [
                function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "down", 40, $event.key, [
                      "Down",
                      "ArrowDown"
                    ])
                  ) {
                    return null
                  }
                  return _vm.keyupDown($event)
                },
                function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "up", 38, $event.key, [
                      "Up",
                      "ArrowUp"
                    ])
                  ) {
                    return null
                  }
                  return _vm.keyupUp($event)
                },
                function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.keyupEnter($event)
                }
              ]
            }
          }),
          _vm._v(" "),
          _vm.loading
            ? _c(
                "i",
                {
                  staticClass:
                    "mdc-text-field__icon mdc-text-field__icon--trailing",
                  attrs: { tabindex: "-1" }
                },
                [_c("bk-loading-spinner")],
                1
              )
            : _c(
                "i",
                {
                  staticClass:
                    "material-icons mdc-text-field__icon mdc-text-field__icon--trailing",
                  attrs: { tabindex: "0", role: "button" }
                },
                [_vm._v(_vm._s(_vm.icon))]
              )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "mdc-menu-surface--anchor" }, [
        _c("div", { staticClass: "mdc-menu mdc-menu-surface" }, [
          _c(
            "ul",
            {
              staticClass: "mdc-list",
              class: { "mdc-list--max-height": _vm.list.length > 5 },
              attrs: { role: "menu", "aria-orientation": "vertical" }
            },
            _vm._l(_vm.list, function(listItem, index) {
              return _c(
                "li",
                {
                  staticClass: "mdc-list-item",
                  class: {
                    "mdc-list-item--selected": _vm.selectedIndex === index
                  },
                  attrs: { role: "menuitem" },
                  on: {
                    click: function($event) {
                      return _vm.select(listItem)
                    }
                  }
                },
                [
                  _c("span", { staticClass: "mdc-list-item__text" }, [
                    _vm._v(
                      _vm._s(listItem.city) +
                        " (" +
                        _vm._s(listItem.district) +
                        ")"
                    )
                  ])
                ]
              )
            }),
            0
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "mdc-text-field-helper-line" }, [
        _c(
          "p",
          {
            staticClass:
              "mdc-text-field-helper-text mdc-text-field-helper-text--persistent",
            class: { "mdc-text-field-helper-text--disabled": !_vm.showHelper },
            attrs: { id: _vm.helperTextId, "aria-hidden": "true" }
          },
          [_vm._v(_vm._s(_vm.helperText))]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }